import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default, { forwardRef } from 'react';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import { useComboboxContext } from './b31cf09859637ddcb4d1a4a83c806ba39869aadedd96320b532d4c7939067785.cfe-internal.js';
import Popper from '../../utils/Popper/53f589867426c0fe9404d76ffe1e6e0db92964f6396b0b62988d89a525e5a08b.cfe-internal.js';
import { FLYOUT_POPPER_OFFSET } from '../../utils/f5e4d8f62716db08736bdf8cd2bfb32640bfafeca586ef59cc354009b4870444.cfe-internal.js';
import { Flyout } from '../../utils/Flyout/09954034ec71aee5026d787e9a48147406abc7ea70b631954c27e40a9ea50559.cfe-internal.js';
import mergeRefs from '../../utils/mergeRefs/836dcb860bec00d9c59bd64df8df6df42430840bc5bfc21b6000935baefbeacd.cfe-internal.js';

var _excluded = ["children", "style", "placement", "portalTarget", "id", "aria-label", "aria-labelledby"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var ComboboxList = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement,
    portalTarget = _ref.portalTarget,
    externalId = _ref.id,
    ariaLabelFromProps = _ref['aria-label'],
    ariaLabelledbyFromProps = _ref['aria-labelledby'],
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useComboboxContext = useComboboxContext(),
    isOpen = _useComboboxContext.isOpen,
    inputRef = _useComboboxContext.inputRef,
    listRef = _useComboboxContext.listRef,
    isLoading = _useComboboxContext.isLoading,
    listContainerId = _useComboboxContext.listContainerId,
    ariaLabel = _useComboboxContext.ariaLabel,
    ariaLabelledby = _useComboboxContext.ariaLabelledby;
  return /*#__PURE__*/React__default.createElement(Popper, {
    open: isOpen,
    placement: placement,
    modifiers: [{
      name: 'offset',
      options: {
        offset: FLYOUT_POPPER_OFFSET
      }
    }],
    portalTarget: portalTarget,
    anchorNode: inputRef.current,
    popper: /*#__PURE__*/React__default.createElement(Flyout, _extends({}, rest, {
      isLoading: isLoading,
      ref: mergeRefs(ref, listRef),
      anchorRef: inputRef,
      style: inputRef.current ? _objectSpread({
        minWidth: inputRef.current.offsetWidth
      }, style) : style,
      id: listContainerId,
      "aria-label": ariaLabelFromProps !== null && ariaLabelFromProps !== void 0 ? ariaLabelFromProps : ariaLabel,
      "aria-labelledby": ariaLabelledbyFromProps !== null && ariaLabelledbyFromProps !== void 0 ? ariaLabelledbyFromProps : ariaLabelledby
    }), children)
  });
});

export { ComboboxList as default };
